import "./style.scss";
import Logo from "@/src/assets/Header/header-logo.png";
import { Link } from "react-router-dom";
import { Study } from "@/src/svg/Study";
import { Account } from "@/src/svg/Account";

const HeaderMob = () => {
  return (
    <section className="header-mob">
      <div className="container">
        <Link className="header-mob-logo" to={"/"}>
          <img src={Logo} alt="Logo" />
        </Link>
        <div className="header-mob-icons">
          <Link to={"/"}>
            <Study />
          </Link>
          <Link to={"/profile"}>
            <Account />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default HeaderMob;
